import { Formik } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import * as Yup from 'yup';
import FileInput from '../../components/Inputs/FileInput';
import Toast from '../../components/Toasts/Toast';
import { objectsConstants } from '../../constants/objects.constants';
import { notasService } from '../../services/notas.service';
import { pedidosService } from '../../services/pedidos.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import DadosNota from './DadosNota';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import { FormGroup } from 'reactstrap';
import { clienteService } from '../../services/cliente.service';
import { atualizarEmissorNoXML } from '../../components/Utils/nfeXmlUtils';
const PEDIDO_VALIDATE = Yup.object().shape({
  itens: Yup.array().of(
    Yup.object().shape({
      produto: Yup.object().shape({
        id: Yup.string().required('Obrigatório'),
      }),
    })
  ),
});

class NotasEdit extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    this.state = {
      entity: {},
      viewMode: false,
      index: null,
      notaOriginal: null,
    };
  }

  componentDidMount() {
    console.log(this.props);
    if (this.props.match.params.id) {
      this.props.loading(true);
      pedidosService.doGet(this.props.match.params.id).then(
        (response) => {
          console.log(response);
          let pedido = response.data;
          console.log(pedido);
          pedidosService.validaEdicao(this.props.match.params.id).then(
            (responseViewMode) => {
              this.setState({ viewMode: responseViewMode.data }, () => {
                if (pedido.itens && pedido.itens.length > 0) {
                  let produtos = _.uniqBy(pedido.itens, 'produto.id');

                  Promise.all(
                    _.map(produtos, (i) => {
                      return pedidosService.findEstoque(i.produto);
                    })
                  ).then(
                    (allResponse) => {
                      let itens = [];
                      _.map(allResponse, (response, index) => {
                        let estoque = _.map(response.data, (e) => {
                          _.map(pedido.itens, (item) => {
                            if (item.observacoes === e.lote) {
                              e.quantidade = item.quantidade;
                            }
                          });
                          return e;
                        });
                        console.log(estoque);
                        let produto = produtos[index].produto;
                        produto.estoque = estoque;
                        itens.push({ produto });
                      });
                      pedido.itens = itens;
                      console.log(pedido);
                      this.props.loading(false);
                      this.setState({ entity: pedido });
                    },
                    (errorEstoque) => {
                      console.log(errorEstoque);
                      this.props.loading(true);
                    }
                  );
                } else {
                  this.setState({ entity: pedido }, () => {
                    this.props.loading(false);
                  });
                }
              });
            },
            (errorViewMode) => {
              console.log(errorViewMode);
              this.props.loading(true);
            }
          );
        },
        (error) => {
          console.log('error');
          console.log(error);
          this.props.loading(false);
        }
      );
    } else {
      this.setState({
        entity: {
          cliente: this.props.user && this.props.user.cliente,
          clienteEmissor: null,
        },
      });
    }
  }

  showError = (messageError) => {
    this.props.error({ message: messageError });
    return '';
  };

  showInfo = (messageInfo) => {
    this.props.info({ message: messageInfo });
    return '';
  };

  clearError = () => {
    this.props.clear();
    return '';
  };

  getXmlOriginal = (xmlBase64OrText) => {
    if (!xmlBase64OrText) {
      return '';
    }

    if (xmlBase64OrText.startsWith('data:text/xml;base64,')) {
      const base64SemPrefixo = xmlBase64OrText.split(',')[1];
      return decodeURIComponent(escape(window.atob(base64SemPrefixo)));
    }

    return xmlBase64OrText;
  };

  montarArquivoNota = (xmlString, arquivoBase = {}) => {
    const base64 = btoa(unescape(encodeURIComponent(xmlString)));

    return {
      ..._.omit(arquivoBase, ['data']),
      data: 'data:text/xml;base64,' + base64,
    };
  };

  getDocumentoDestinatario = (notaImportada) => {
    return (
      _.get(notaImportada, 'nfe.infNFe.dest.cnpj') ||
      _.get(notaImportada, 'nfe.infNFe.dest.cpf') ||
      null
    );
  };

  getCodigoClienteDaNota = (notaImportada) => {
    const infoComplementar = _.get(notaImportada, 'nfe.infNFe.infAdic.infCpl', '');
    const match = infoComplementar.match(/Cod\.Cliente:\s*([0-9]+)/i);
    return match ? match[1] : null;
  };

  montarClienteFallback = (notaImportada, codigoCliente) => {
    const nomeFantasia = _.get(notaImportada, 'nfe.infNFe.dest.xnome');
    const cnpjCpf = this.getDocumentoDestinatario(notaImportada);

    return {
      codigoCliente,
      nomeFantasia,
      cnpjCpf,
      label: nomeFantasia ? `${codigoCliente} - ${nomeFantasia}` : codigoCliente,
      origemNotaFallback: true,
    };
  };

  clienteEhFallback = (cliente) => {
    return Boolean(_.get(cliente, 'origemNotaFallback'));
  };

  normalizarDocumento = (documento) => {
    return String(documento || '').replace(/\D/g, '');
  };

  clienteSelecionadoEhDestinatario = (clienteSelecionado, notaImportada) => {
    const documentoSelecionado = this.normalizarDocumento(
      _.get(clienteSelecionado, 'cnpjCpf')
    );
    const documentoDestinatario = this.normalizarDocumento(
      this.getDocumentoDestinatario(notaImportada)
    );

    return Boolean(
      documentoSelecionado &&
        documentoDestinatario &&
        documentoSelecionado === documentoDestinatario
    );
  };

  resolverClienteDaNota = async (notaImportada) => {
    const documento = this.getDocumentoDestinatario(notaImportada);
    if (documento) {
      try {
        const response = await clienteService.findByDocumento(documento);
        if (response && response.data) {
          return response.data;
        }
      } catch (error) {
        console.warn('Cliente não encontrado por documento da nota:', error);
      }
    }

    const codigoCliente = this.getCodigoClienteDaNota(notaImportada);
    if (codigoCliente) {
      try {
        const response = await clienteService.findByCodigoCliente(codigoCliente);
        if (response && response.data) {
          return response.data;
        }
      } catch (error) {
        console.warn('Cliente não encontrado por código da nota:', error);
      }

      return this.montarClienteFallback(notaImportada, codigoCliente);
    }

    return null;
  };

  sincronizarClienteDaNota = async (notaImportada, setFieldValue, clienteAtual) => {
    if (
      _.get(clienteAtual, 'codigoCliente') &&
      !this.clienteEhFallback(clienteAtual)
    ) {
      return;
    }

    const clienteResolvido = await this.resolverClienteDaNota(notaImportada);
    if (clienteResolvido) {
      setFieldValue('cliente', clienteResolvido);
    }
  };

  reimportarNotaComCliente = (
    xmlBase64OrText,
    cliente,
    setFieldValue,
    arquivoBase = {},
    clienteAtual = null
  ) => {
    try {
      const xmlOriginal = this.getXmlOriginal(xmlBase64OrText);

      const xmlAlterado = cliente
        ? atualizarEmissorNoXML(xmlOriginal, cliente)
        : xmlOriginal;
      const novoArquivo = this.montarArquivoNota(xmlAlterado, arquivoBase);

      this.props.loading(true);

      notasService
        .importarNota(novoArquivo)
        .then(async (r) => {
          setFieldValue('notaImportada', r.data);
          setFieldValue('nota', novoArquivo);
          await this.sincronizarClienteDaNota(r.data, setFieldValue, clienteAtual);
        })
        .catch((err) => {
          console.error('Erro ao importar nota:', err);
          this.props.error({ message: 'Erro ao importar a nota fiscal' });
        })
        .finally(() => {
          this.props.loading(false);
        });
    } catch (err) {
      console.warn('Erro ao processar XML:', err);
      this.props.error({ message: 'Erro ao processar o XML da nota fiscal' });
    }
  };

  handleClienteEmissorChange = (
    clienteEmissor,
    setFieldValue,
    clienteAtual,
    notaImportada
  ) => {
    setFieldValue('clienteEmissor', clienteEmissor);

    let clienteAtualEfetivo = clienteAtual;

    if (
      clienteEmissor &&
      notaImportada &&
      this.clienteSelecionadoEhDestinatario(clienteEmissor, notaImportada)
    ) {
      clienteAtualEfetivo = {
        ...clienteEmissor,
        origemNotaFallback: false,
      };
      setFieldValue('cliente', clienteAtualEfetivo);
    }

    const { notaOriginal } = this.state;
    if (notaOriginal && notaOriginal.data) {
      this.reimportarNotaComCliente(
        notaOriginal.data,
        clienteEmissor,
        setFieldValue,
        notaOriginal,
        clienteAtualEfetivo
      );
    }
  };

  handleLimparClienteEmissor = (setFieldValue, clienteAtual) => {
    this.handleClienteEmissorChange(null, setFieldValue, clienteAtual, null);
  };

  render() {
    const { entity } = this.state;
    return (
      <React.Fragment>
        <TopoTitleComponente mainTitle="Notas" subTitle=" " canBack={false} />
        <Formik
          validationSchema={PEDIDO_VALIDATE}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize={true}
          onSubmit={(values, actions) => {
            if (
              !_.get(values, 'cliente.codigoCliente') ||
              this.clienteEhFallback(values.cliente)
            ) {
              actions.setSubmitting(false);
              this.props.error({
                message:
                  'Cliente da nota não identificado no Integrados. Selecione um cliente real cadastrado com o mesmo CNPJ do destinatário.',
              });
              return;
            }

            this.props.loading(true);
            const payload = _.omit(values, ['clienteEmissor']);
            notasService
              .save(payload)
              .then((r) => {
                let msg = 'Omie ok - WMS ok';

                if (r && r.data) {
                  if (typeof r.data === 'string') {
                    msg = r.data;
                  } else if (r.data.message) {
                    msg = r.data.message;
                  }
                }

                this.props.history.push('/notas');
                actions.setSubmitting(false);
                this.props.success({ message: msg });
                this.setState({ notaOriginal: null });
                actions.resetForm({
                  values: {
                    cliente: null,
                    clienteEmissor: null,
                    nota: null,
                    notaImportada: null,
                  },
                });
              })
              .catch((e) => {
                console.error('Erro ao enviar Nota', e);

                let msg = 'Erro ao enviar Nota';

                if (e.response && e.response.data) {
                  // tenta extrair a mensagem vinda do backend
                  if (typeof e.response.data === 'string') {
                    msg = e.response.data;
                  } else if (e.response.data.message) {
                    msg = e.response.data.message;
                  }
                }

                this.props.error({
                  message: msg,
                });
              })

              .finally(() => {
                this.props.loading(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} noValidate>
              <div className="flex-column p-5">
                <Toast />

                {!_.isEmpty(errors) &&
                  this.showError(objectsConstants.messageCampoObrigatorio)}

                {values.id}
                <div className="cardSeculus d-flex flex-column mb-0">
                  <div className="topoCard d-flex flex-column flex-sm-row">
                    <h3 className="flex-grow-1">Notas</h3>
                  </div>

                  <div className="form-row">
                    <FormGroup className="col-12 col-xl-6">
                      <FormSelectInput
                        name="clienteEmissor"
                        id="clienteEmissor"
                        label="Informe um cliente para substituir o emissor da NFe (OPCIONAL)"
                        placeholder="Informe um cliente para substituir o emissor da NFe (OPCIONAL)"
                        valueKey="codigoCliente"
                        labelKey="label"
                        required={false}
                        returnFullObject={true}
                        service={clienteService.findAll}
                        onChange={(name, value) => {
                          this.handleClienteEmissorChange(
                            value,
                            setFieldValue,
                            values.cliente,
                            values.notaImportada
                          );
                        }}
                        value={values.clienteEmissor}
                      />
                    </FormGroup>
                    <FormGroup className="col-12 col-xl-3 d-flex align-items-end pb-1">
                      <button
                        type="button"
                        className="btn btn-secondary btn30 white"
                        disabled={isSubmitting}
                        onClick={() =>
                          this.handleLimparClienteEmissor(
                            setFieldValue,
                            values.cliente,
                            values.notaImportada
                          )
                        }
                      >
                        Limpar Cliente
                      </button>
                    </FormGroup>
                    <FormGroup className="col-12 col-xl-7">
                      <FileInput
                        emptyLabel="Importar Nota Fiscal"
                        name="Nota Fiscal"
                        entity={values}
                        fileItem={values.nota}
                        parseAsText={true}
                        onChange={(name, value) => {
                          if (!value) {
                            this.setState({ notaOriginal: null });
                            setFieldValue('nota', null);
                            setFieldValue('notaImportada', null);
                            return;
                          }

                          if (value && value.data) {
                            this.setState({ notaOriginal: value }, () => {
                              this.reimportarNotaComCliente(
                                value.data,
                                values.clienteEmissor,
                                setFieldValue,
                                value,
                                values.cliente
                              );
                            });
                          }
                        }}
                        className={'btn btn-secondary'}
                        readOnly={this.state.viewMode}
                      />
                    </FormGroup>
                    {values.notaImportada && (
                      <DadosNota
                        infNFe={values.notaImportada.nfe.infNFe}
                        setFieldValue={setFieldValue}
                        values={values}
                        loading={this.props.loading}
                      />
                    )}
                  </div>
                  {!this.state.viewMode && (
                    <div className="d-flex flex-row flex-sm-row ">
                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="button"
                          className="btn btn-secondary btn30 white"
                          disabled={isSubmitting}
                          onClick={() => this.props.history.goBack()}
                        >
                          Cancelar
                        </button>
                      </div>
                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="submit"
                          //isabled={isSubmitting||!values.itens||values.itens.length==0}
                          className="btn btn-secondary btn30 green"
                        >
                          Enviar Nota
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;

  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  {
    forwardRef: true,
  }
)(NotasEdit);
